import './index.scss';
import ModalManager from 'utils/modal_manager';
import {handleApiError} from 'utils/api_error_handler';

export default class SendMessageModal {
  static open(recipientName, recipientId) {
    $('.js-recipient-name', '#js-send-message-modal').html(recipientName);
    ModalManager.open('#js-send-message-modal', res => {
      if (!res) return;

      Thor.Conversation.create({}, {
        data: {
          conversation: {
            recipient_id: recipientId,
            messages_attributes: [
              {
                text: res.text
              }
            ]
          }
        }
      }).then(() => {
        toastr.success(`Mensagem enviada com sucesso para ${recipientName}!`);
      }).catch(({response}) => {
        handleApiError('Ops! Não foi possível enviar a mensagem nesse momento!', response);
      });
    });
  }
}
